import { useQuery } from "@tanstack/react-query";
import type { Order } from "../../../../services/orders/orders.types";
import { OrdersService } from "../../../../services/orders/orders-service";

let ordersService: OrdersService | undefined;
const getOrdersService = (): OrdersService => (ordersService ??= new OrdersService());

export const amznhamOrderQueryKey = (orderId: string | undefined) => ["amznhamOrder", orderId];

export const useAmznhamOrder = (orderId: string | undefined) =>
  useQuery<Order | null, Error>({
    queryKey: amznhamOrderQueryKey(orderId),
    queryFn: () => getOrdersService().getOrder(orderId as string),
    enabled: Boolean(orderId),
  });
